import { render } from "./HintsItemView.vue?vue&type=template&id=0e36832e&scoped=true"
import script from "./HintsItemView.vue?vue&type=script&lang=js"
export * from "./HintsItemView.vue?vue&type=script&lang=js"

import "./HintsItemView.vue?vue&type=style&index=0&id=0e36832e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e36832e"]])

export default __exports__